<template>
    <a-drawer :title="title" width="600" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="组织名称" prop="name">
                <a-input v-model="field.name" placeholder="请填写组织名称" />
            </a-form-model-item>
            <a-form-model-item label="标签" prop="tags">
                <a-input v-model="field.tags" placeholder="请填写标签内容，多个以小写英文逗号区分" />
            </a-form-model-item>
            <a-form-model-item label="组织类型" prop="type">
                <a-select v-model="field.type" placeholder="请选择组织类型">
                    <template v-for="(val, key) in $enums.TeamType">
                        <a-select-option :value="key" :key="key">
                            {{ val }}
                        </a-select-option>
                    </template>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="申请配置" prop="ma">
                <a-checkbox :checked="field.ma" @change="e => (field.ma = e.target.checked)">
                    个人申请
                </a-checkbox>
                <a-checkbox :checked="field.ca" @change="e => (field.ca = e.target.checked)">
                    心理师申请
                </a-checkbox>
                <a-checkbox :checked="field.ua" @change="e => (field.ua = e.target.checked)">
                    机构申请
                </a-checkbox>
            </a-form-model-item>
            <a-form-model-item label="组织宗旨" prop="aim">
                <a-textarea v-model="field.aim" placeholder="请填写组织宗旨" :auto-size="{ minRows: 3, maxRows: 3 }" />
            </a-form-model-item>
            <a-form-model-item label="组织简介" prop="memo">
                <a-textarea v-model="field.memo" placeholder="请填写组织简介" :auto-size="{ minRows: 3, maxRows: 3 }" />
            </a-form-model-item>
            <a-form-model-item label="负责人" prop="link">
                <a-input v-model="field.link" placeholder="请填写负责人信息" />
            </a-form-model-item>
            <a-form-model-item label="主要活动" prop="act">
                <a-textarea v-model="field.act" placeholder="请填写主要活动" :auto-size="{ minRows: 3, maxRows: 3 }" />
            </a-form-model-item>
            <a-form-model-item label="活动周期" prop="cycle">
                <a-input v-model="field.cycle" placeholder="请填写活动周期" />
            </a-form-model-item>
            <a-form-model-item label="活动形式" prop="info">
                <a-textarea v-model="field.info" placeholder="请填写活动形式" :auto-size="{ minRows: 3, maxRows: 3 }" />
            </a-form-model-item>
            <a-form-model-item label="项目名称" prop="pro">
                <a-input v-model="field.pro" placeholder="请填写项目名称" />
            </a-form-model-item>
            <a-form-model-item label="指导单位" prop="unit">
                <a-input v-model="field.unit" placeholder="请填写指导单位" />
            </a-form-model-item>
            <a-form-model-item label="秘书处" prop="mgr">
                <a-input v-model="field.mgr" placeholder="请填写秘书处" />
            </a-form-model-item>
            <a-form-model-item label="获得荣誉" prop="honor">
                <a-textarea v-model="field.honor" placeholder="请填写获得荣誉" :auto-size="{ minRows: 3, maxRows: 3 }" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            field: {
                id: '',
                name: '',
                tags: '',
                type: 'TM01',
                ma: true,
                ca: true,
                ua: true,
                aim: '',
                memo: '',
                act: '',
                cycle: '',
                info: '',
                pro: '',
                unit: '',
                mgr: '',
                link: '',
                honor: ''
            },
            rules: {
                name: [{ required: true, message: '请填写组织名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择组织类型', trigger: 'change' }],
                ma: [{ required: true, message: '请选择是否允许个人加入', trigger: 'change' }],
                ca: [{ required: true, message: '请选择是否允许心理师加入', trigger: 'change' }],
                ua: [{ required: true, message: '请选择是否允许机构加入', trigger: 'change' }],
                aim: [{ required: true, message: '请填写组织宗旨', trigger: 'blur' }],
                memo: [{ required: true, message: '请填写组织简介', trigger: 'blur' }],
                act: [{ required: true, message: '请填写主要活动', trigger: 'blur' }],
                cycle: [{ required: true, message: '请填写活动周期', trigger: 'blur' }],
                info: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
                pro: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
                unit: [{ required: true, message: '请填写指导单位', trigger: 'blur' }],
                mgr: [{ required: true, message: '请填写秘书处', trigger: 'blur' }],
                link: [{ required: true, message: '请填写负责人信息', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
    },
    methods: {
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/unit/team/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
